import { v4 } from "uuid";
import { Category } from "../nyt";
import { HydratedBook } from "./gameStateMachine";

export async function hydrateBooksAndCategories(
  bookCategories: Category[]
): Promise<{
  sortedBooks: HydratedBook[];
  selectedCategories: string[];
}> {
  const selectedCategories = bookCategories.map((category) => {
    return category.category_name;
  });

  const sortedBooks = bookCategories.flatMap(
    ({ books, category_name: categoryName }) => {
      return books.map((book) => {
        return {
          title: book.title,
          author: book.author,
          image: book.img || "",
          category: categoryName,
          id: v4(),
          description: book.description,
        };
      });
    }
  );

  return {
    sortedBooks,
    selectedCategories,
  };
}
